import React, { useState, useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Select from "react-select";
import EditIcon from "@material-ui/icons/Edit";
import TransferWithinAStationIcon from "@material-ui/icons/TransferWithinAStation";
import { withStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import ProviderEditModal from "../../../../components/ProviderEditModal";
import Button from "../../../../components/Button";
import ProviderSearchBar from "../../../../components/ProviderSearchBar";
import * as adminApi from "../../../../services/api/admin";
import HistoryTableModal from "./Modal/historyTable";
import {
  fetchProvidersPage,
  activateProvider,
  deactivateProvider,
  updateProvider,
  createProvider,
  enableProvider,
  disableProvider,
} from "../../../../services/api";

import Avatar from "../../../../components/Avatar";
import RejectionModal from "./Modal/rejectionReasonModal";

function Providers(props) {
  const {
    classes: { loading, actions },
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [providers, setProviders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [providerUnderEdit, setProviderUnderEdit] = useState({});
  const [openProviderEditModal, setOpenProviderEditModal] = useState(false);
  const [providersSearchTerm, setProvidersSearchTerm] = useState("");
  const [rejectModal, setRejectModal] = useState(false);
  const [myName, setMyName] = useState("");
  const [selectedSpecialty, setSelectedSpecialty] = useState("All");
  const [historyTableModal, sethistoryTableModal] = useState(false);
  const [allData, setAllData] = useState({});
  const [providerLoading, setProviderLoading] = useState(false);


  //providerLoading
  const InactiveData = () => {
    const Inactivefilter = allData?.filter((item) => item.isactive === false);
    setProviders(Inactivefilter);
    console.log("Inactivefilter", Inactivefilter);
  };
  const ActiveData = () => {
    const Activefilter = allData?.filter((item) => item.isactive === true);
    setProviders(Activefilter);
    console.log("Activefilter", Activefilter);
  };

  useEffect(() => {
    if (selectedSpecialty === "All") {
      if (Object.keys(allData).length !== 0) {
        setProviders(allData);
      }
    } else if (selectedSpecialty === "Inactive") {
      ActiveData();
    } else if (selectedSpecialty === "Active") {
      InactiveData();
    }
  }, [selectedSpecialty]);

  useEffect(() => {
    fetchProviders();
  }, []);

  const fetchProviders = async (searchTerm = null, pageIndex = 0) => {
    try {
      setIsLoading(true);
      const page = await fetchProvidersPage({
        searchTerm,
        limit: 20,
        offset: 20 * pageIndex,
        tolerance: 7,
      });
      setProviders(page);
      setAllData(page);
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Unable to fetch providers, please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const masqueradeAs = async ({ userId }) => {
    try {
      await adminApi.masqueradeAs(userId);
      window.location.href = "/admin";
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Unable to masquerade, please try again.");
    }
  };

  const activate = async (provider) => {
    try {
      if (!provider.active) {
        await activateProvider(provider);
      } else {
        await deactivateProvider(provider);
      }
      enqueueSnackbar("Active status updated!");
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Unable to update active status on provider.");
    } finally {
      await fetchProviders();
    }
  };

  const enableProviders = async (data) => {
    const enableData = {
      id: data.id,
      enable: true,
    };
    try {
      setProviderLoading(true)
      await enableProvider(enableData);
      enqueueSnackbar("Active status updated!");
    } catch (err) {
      console.error("ERR OCCURED IN enableProviders :::", err);
    } finally {
      await fetchProviders();
      setProviderLoading(false)
    }
  };

  const onPageChange = (pageIndex) => {
    fetchProviders(providersSearchTerm, pageIndex);
  };

  const onNewProvider = () => {
    setProviderUnderEdit({});
    setOpenProviderEditModal(true);
  };

  const onEditProvider = (provider) => {
    setProviderUnderEdit(provider);
    setOpenProviderEditModal(true);
  };
  const onHistoryDisplay = (data) => {
    sethistoryTableModal(true);
    setMyName(data);
  };

  const onSaveProviderProfile = async (provider) => {
    try {
      if (provider.id) {
        await updateProvider(provider);
      } else {
        await createProvider(provider);
      }
      enqueueSnackbar("Provider updated!");
      onClose();
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Unable to save provider, please try again.");
    } finally {
      fetchProviders();
    }
  };

  const onSaveProviderTenancies = async (tenancies) => {
    try {
      await Promise.all(
        tenancies.map((tenancy) => {
          if (tenancy.id) {
            return adminApi.updateTenancy(tenancy);
          } else {
            return adminApi.createTenancy(tenancy);
          }
        })
      );
      enqueueSnackbar("Provider updated!");
      onClose();
    } catch (err) {
      console.log(err);
      enqueueSnackbar("Oops, updating locations for provider failed");
    } finally {
      fetchProviders();
    }
  };

  const onClose = () => {
    setOpenProviderEditModal(false);
    setProviderUnderEdit({});
  };

  const handleProviderToSearch = (provider) => {

    if (provider) {
      const name = `${provider.firstName} ${provider.lastName}`;
      fetchProviders(name);
    }
  };

  const handleProviderEditingSearchTerm = (searchTerm) => {
    setProvidersSearchTerm(searchTerm);
  };
  const specialties = [
    {
      name: "All",
      value: "All",
    },
    {
      name: "Active",
      value: "Active",
    },
    {
      name: "Inactive",
      value: "Inactive",
    },
  ];

  return isLoading ? (
    <div className={loading}>
      <CircularProgress />
    </div>
  ) : props?.value === "providers" ? (
    <>
      <div className="lesser">
        <div className="width-lesser">
          <ProviderSearchBar
            clearable={false}
            onSelect={handleProviderToSearch}
            onChange={handleProviderEditingSearchTerm}
          />
        </div>
        <div className="Select-widther">
          <Select
            aria-label=""
            placeholder={selectedSpecialty}
            value={selectedSpecialty}
            onChange={(e) => {
              setSelectedSpecialty(e.value);
            }}
            options={[
              ...specialties.map((specialty) => ({
                value: specialty.value,
                label: specialty.name,
              })),
            ]}
            sx={{ width: "100%" }}
          />
        </div>
      </div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Provider</TableCell>
            <TableCell>Practice</TableCell>
            <TableCell>Locations</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {providers.map((provider) => (
            <TableRow key={provider.id}>
              <TableCell width="300">
                <Grid container alignItems="center">
                  <Grid item xs={12} xl={3}>
                    <Avatar
                      providerId={provider.id}
                      customStyles={{
                        width: "40px",
                        height: "40px",
                        marginLeft: "0px",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} xl={9}>
                    {provider.name}
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell width="250">{provider.practice.name}</TableCell>
              <TableCell width="400">
                {provider.tenancies
                  .filter((l) => l.active)
                  .map((l) => l.locationShortName || l.location)
                  .join(", ")}
              </TableCell>
              <TableCell>
                <FormGroup row>
                  <div className="lesser">
                    <IconButton onClick={() => masqueradeAs(provider)}>
                      <TransferWithinAStationIcon />
                    </IconButton>
                    <IconButton onClick={() => onEditProvider(provider)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => onHistoryDisplay(provider)}>
                      <RemoveRedEyeIcon />
                    </IconButton>
                  </div>

                  <FormControlLabel
                    control={
                      <Checkbox
                      disabled={providerLoading}
                        checked={provider.isactive === false}
                        onChange={() => {
                          if (provider.isactive === false) {
                            setRejectModal(true);
                            setMyName(provider);
                          } else {
                            enableProviders(provider);
                          }
                        }}
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={provider.active}
                        onChange={() => activate(provider)}
                      />
                    }
                    label="Premium"
                  />
                </FormGroup>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Grid container justifyContent="flex-end" classes={{ container: actions }}>
        <Grid item xs={12} md={4} xl={2}>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={onNewProvider}
          >
            + Add Provider
          </Button>
        </Grid>
      </Grid>

      {openProviderEditModal && (
        <ProviderEditModal
          open={openProviderEditModal}
          provider={providerUnderEdit}
          saveProfile={onSaveProviderProfile}
          saveTenancies={onSaveProviderTenancies}
          admin={true}
          onClose={onClose}
        />
      )}
      {rejectModal && (
        <RejectionModal
          open={rejectModal}
          setRejectModal={setRejectModal}
          onClose={() => setRejectModal(false)}
          data={myName}
          fetchProviders={fetchProviders}
        />
      )}
      {historyTableModal && (
        <HistoryTableModal
          open={historyTableModal}
          onClose={() => sethistoryTableModal(false)}
          data={myName}
        />
      )}
    </>
  ) : (
    ""
  );
}

const styles = () => ({
  loading: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  actions: {
    marginTop: "2em",
  },
});

export default withStyles(styles)(Providers);
